import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";

orderDetailsButtonSetStyles.cancelButton = {
    buttonType: "solid",
    variant: "secondary",
}

orderDetailsButtonSetStyles.printButton = {
    buttonType: "solid",
    variant: "secondary",
}